export default function remoteConfigStatus(props) {
  const {
    appName, appVersion, maintenanceData, refreshAppData, refreshAppSpecificData,
  } = props;

  function isValidJSONString(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  const isNewerVersion = (v1, v2) => {
    const parts1 = v1.split('-');
    const parts2 = v2.split('-');
    if (Number(parts1[0]) > Number(parts2[0])) {
      return true;
    }
    return Number(parts1[1]) > Number(parts2[1]);
  };

  function hasMaintenance() {
    if (!isValidJSONString(maintenanceData)) {
      return false;
    }
    const jsonData = JSON.parse(maintenanceData);
    return jsonData.enabled && jsonData.apps.includes(appName);
  }

  function hasRefreshApp() {
    if (!isValidJSONString(refreshAppData)) {
      return false;
    }
    const jsonData = JSON.parse(refreshAppData);
    return jsonData.shouldRefresh
        && jsonData.apps.includes(appName)
        && !isNewerVersion(appVersion, jsonData.olderThan);
  }

  function hasRefreshAppSpecific() {
    if (!isValidJSONString(refreshAppSpecificData)) {
      return false;
    }
    const jsonData = JSON.parse(refreshAppSpecificData);
    return jsonData.shouldRefresh
        && jsonData.apps.includes(appName)
        && jsonData.versions.some((v) => appVersion.includes(v));
  }

  // console.log('RemoteConfig Maintenance: ', maintenanceData);
  // console.log('RemoteConfig Refresh: ', maintenanceData);
  // console.log('RemoteConfig Refresh Specific: ', maintenanceData);

  if (hasMaintenance()) {
    return { status: 'maintenance', info: '' };
  }
  if (hasRefreshApp()) {
    return { status: 'refresh', info: JSON.parse(refreshAppData).info };
  }
  if (hasRefreshAppSpecific()) {
    return { status: 'refresh', info: JSON.parse(refreshAppSpecificData).info };
  }
  return { status: 'none', info: '' };
}
